import React, { useState } from 'react';
import { Field, Form, Formik } from 'formik';
import { CircularProgress } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { DATE_RANGE_SELECTED, getDateRangeRadioOptions } from '../ReportsUtils';
import { JANUARY, MONTHS_OPTIONS } from '../../../../utils/dates-const';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CommonButton from '../../../common/CommonButton';
import LoadingSnackbar from '../../../common/LoadingSnackbar';
import { formatTimestampAsDate, upUntilCurrentMonthOnly } from '../../../../utils/dates-utils';
import CommonSelectField from '../../../common/form/CommonSelectField';
import { sie4Styles } from './Sie4ReportForm';
import { downloadExcelFile, downloadSie4File, fetchSie4Reports } from '../../../../actions/sie4-actions';
import VerticalAlignBottomOutlined from '@material-ui/icons/VerticalAlignBottomOutlined';
import { clearStandardReports } from '../../../../actions/report-actions';

const Sie4ExportForm = ({
                          reportName,
                          machinesOptions,
                          setFormValues,
                          fetchSie4Reports,
                          machineName,
                          downloadSie4File,
                          downloadExcelFile,
                        }) => {
  const [dateRangeOption, setDateRangeOption] = useState(DATE_RANGE_SELECTED);
  const [loadingProgress, setLoadingProgress] = useState();
  const MONTHS_THIS_YEAR = upUntilCurrentMonthOnly(MONTHS_OPTIONS);
  const classes = sie4Styles();
  
  const handleExcelDownload = (values) => {
    const dateFrom = formatTimestampAsDate(values.dateFrom);
    const dateTo = formatTimestampAsDate(values.dateTo);
    if (dateFrom && dateTo) {
      downloadExcelFile(values.machineIDs, machineName, dateFrom, dateTo, setLoadingProgress);
    }
  };
  
  const handleSie4Download = (values) => {
    const dateFrom = formatTimestampAsDate(values.dateFrom);
    const dateTo = formatTimestampAsDate(values.dateTo);
    if (dateFrom && dateTo) {
      downloadSie4File(values.machineIDs, machineName, dateFrom, dateTo, setLoadingProgress);
    }
  };
  
  return (
    <>
      <Formik
        initialValues={{
          machineIDs: machinesOptions[0].value,
          dateFrom: JANUARY.option.dateFrom,
          dateTo: JANUARY.option.dateTo,
          dateRange: JANUARY.value,
        }}
        onSubmit={(values, formikHelpers) => {
          setFormValues(values);
          fetchSie4Reports(reportName, values.machineIDs, formatTimestampAsDate(values.dateFrom), formatTimestampAsDate(values.dateTo), formikHelpers, setLoadingProgress);
        }}>
        
        {({ isSubmitting, values, isValid, submitForm, setFieldValue }) => {
          return (
            <Form className={classes.form}>
              <div className={classes.formContent}>
                <Field
                  wide
                  atLeastOneElement
                  name="machineIDs"
                  label={<FormattedMessage
                    id="field.cash.register"
                    defaultMessage="Cash Register"
                  />}
                  options={[...machinesOptions]}
                  component={CommonSelectField}
                />
  
                {getDateRangeRadioOptions(setDateRangeOption, values, setFieldValue, dateRangeOption, classes, MONTHS_THIS_YEAR)}
              </div>
  
              {isSubmitting && <CircularProgress className={classes.loadingBar} />}
  
              <div className={classes.buttonGroup}>
                <CommonButton
                  label={'SIE4'}
                  endIcon={<VerticalAlignBottomOutlined />}
                  onClick={() => handleSie4Download(values)}
                />
                <CommonButton
                  isAnimated
                  onClick={() => isValid && submitForm()}
                  size="large"
                  label={
                    <FormattedMessage
                      id="search"
                      defaultMessage="Search"
                    />}
                  disabled={isSubmitting || !values.machineIDs || !values.dateFrom || !values.dateTo || !isValid}
                />
                <CommonButton
                  label={'Excel'}
                  endIcon={<VerticalAlignBottomOutlined />}
                  onClick={() => handleExcelDownload(values)}
                />
              </div>
              <div className={classes.infoText}>
                <FormattedMessage id="sie4-export-search-text"
                                  defaultMessage='"Search" serves only as a visual representation of the SIE-file. Select "SIE4" or "Excel" for direct export.' />
              </div>
            </Form>
          );
        }}
      </Formik>
      
      <LoadingSnackbar
        progress={loadingProgress}
        label={<FormattedMessage id="loading" defaultMessage="Loading" />}
      />
    </>
  );
};

Sie4ExportForm.propTypes = {
  reportName: PropTypes.string,
  machines: PropTypes.array,
  setFormValues: PropTypes.func,
};

const decorate = compose(
  connect(
    store => ({
      machines: store.user.machines,
      reports: store.report.standard,
    }),
    dispatch => bindActionCreators({
      fetchSie4Reports,
      clearStandardReports,
      downloadSie4File,
      downloadExcelFile,
    }, dispatch)),
);

export default decorate(Sie4ExportForm);
